import React from "react";
import {
	Box
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	Header,
	Navigation
} from "./components";
import PopUpBuyNumber from "../components/PopUpBuyNumber";
import { useBuyNumber } from "../contexts/BuyNumberContext";

const Main = ({ children }) => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<Header/>
			<div className={classes.body}>
				{children}
			</div>
			<Navigation/>
			<PopUpBuyNumber/>
		</div>
	)
}

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column',

		width: '100%',
		height: '100vh',
		minHeight: '100vh',
		position: 'relative',
		background: theme.palette.background.default,
	},
	body: {
		flex: 1,
		display: 'flex',
		overflow: 'auto',
		paddingTop: "12px",
		paddingBottom: "78px",
		boxSizing: "border-box",
		flexDirection: 'column',
	},
}));

export default Main
